"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelProtocol.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelProtocol = void 0;
/**
 * Defines possible values for the protocol of a {@link TunnelPort}.
 */
var TunnelProtocol;
(function (TunnelProtocol) {
    /**
     * The protocol is automatically detected. (TODO: Define detection semantics.)
     */
    TunnelProtocol["Auto"] = "auto";
    /**
     * Unknown TCP protocol.
     */
    TunnelProtocol["Tcp"] = "tcp";
    /**
     * Unknown UDP protocol.
     */
    TunnelProtocol["Udp"] = "udp";
    /**
     * SSH protocol.
     */
    TunnelProtocol["Ssh"] = "ssh";
    /**
     * Remote desktop protocol.
     */
    TunnelProtocol["Rdp"] = "rdp";
    /**
     * HTTP protocol.
     */
    TunnelProtocol["Http"] = "http";
    /**
     * HTTPS protocol.
     */
    TunnelProtocol["Https"] = "https";
})(TunnelProtocol = exports.TunnelProtocol || (exports.TunnelProtocol = {}));
//# sourceMappingURL=tunnelProtocol.js.map